<template>
    <img v-if="url && !error" :src="url" :alt="`${firstName} ${lastName}`" class="avatar" :class="[{ 'sm': size === 'sm' }, { 'md': size === 'md' }]" @error="onError" :style="{'width': width + 'px', 'height': height + 'px'}">

    <div v-else class="rounded-full bg-grayxlight flex justify-center items-center text-gray text-sm"
        :class="[{ 'w-[33px] h-[33px] min-w-[33px]': size === 'sm' }, { 'w-[53px] h-[53px]': size === 'md' }, {'text-xs': fontSize === 'xs'}]" :style="{'width': width + 'px', 'height': height + 'px'}">
        {{ initials }}
    </div>
</template>

<script setup lang="ts">
type SizeType = 'sm' | 'md' | 'lg'
import { computed, ref } from 'vue'

const props = withDefaults(defineProps<{
    firstName: string,
    lastName: string,
    url?:string,
    size?: SizeType,
    fontSize?: string,
    width?: string,
    height?: string
}>(), {
    size: 'sm' // Default value
});
const error = ref(false)
const initials = computed(() => (props.lastName[0] + props.firstName[0]))

const onError = () => {
    error.value = true
}
</script>

<style scoped>
    .sm {
        width: 33px;
        height: 33px;
    }
    .md {
        width: 53px;
        height: 53px;
    }
    .avatar {
        object-fit: cover;
        border-radius: 50%;
    }
</style>

